export default {
  welcome: "后台数据管理系统",
  greeting: "你好，{name}！",
};
